const state = {
  type: 0,
  hidden: false
}

const getters = {
}

const mutations = {
  updateCursorType: (state, payload) => {
    state.type = payload
  },
  updateCursorHidden: (state, payload) => {
    state.hidden = payload
  }
}

const actions = {
}

export default {
  state,
  getters,
  mutations,
  actions
}
